module.exports = __webpack_public_path__ + "media/b2cvideo.dee7df3d.mp4";